module.exports = __webpack_public_path__ + "static/media/google-photos.fdc13991.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/google-photos.png
 ** module id = 222
 ** module chunks = 0
 **/